import { SUBSCRIPTIONS_CUSTOMER_CONTROLLER_ROOT_PATH } from "./root";

export const SUBSCRIPTIONS_CUSTOMER_CANCEL_SUBSCRIPTION_PATH_SUFFIX = "/cancel";
/** /customer/subscription/cancel */
export const SUBSCRIPTIONS_CUSTOMER_CANCEL_SUBSCRIPTION_PATH = `${SUBSCRIPTIONS_CUSTOMER_CONTROLLER_ROOT_PATH}${SUBSCRIPTIONS_CUSTOMER_CANCEL_SUBSCRIPTION_PATH_SUFFIX}`;
